const routes = [
  {
    path: "/whatsapp-atendimento",
    component: () => import("./views/Attendances.vue"),
    name: "WhatsApp"
  },
  {
    path: "/whatsapp-atendimento/configuracao",
    redirect: "/whatsapp-atendimento"
  }
];

export default {
  routes
};
